const enum DocumentCategory {
    DentalCredential = 1,
    WorkHistory = 2,
    Attestation = 3,
    Location = 4,
    SignedDocument = 5,
    CredentialingApplication = 6,
}

const enum DocumentSubCategory {
    StateLicense = 1,
    DEALicense = 2,
    MalpracticeInsuranceLicense = 3,
    SpecialtyLicense = 4,
    AnesthesiaSedationLicense = 5,
    ControlledSubstanceLicense = 6,
    AdditionalDocument1 = 7,
    AdditionalDocument2 = 8,
    AdditionalDocument3 = 9,
    CDSLicense = 10,
    AttestationDocument = 11,
    CorporateAuthorityForm = 12,
    UniformRequirements = 13,
    ParticipatingAgreement = 14,
    MissouriMedicareAdvantage = 15,
    W9Form = 16,
    CredentialingApplication = 17,
}

const DocumentSubCategoryName: any = {
    '1': 'StateLicense',
    '2': 'DEALicense',
    '3': 'MalpracticeInsuranceLicense',
    '4': 'SpecialtyLicense',
    '5': 'AnesthesiaSedationLicense',
    '6': 'ControlledSubstanceLicense',
    '7': 'AdditionalDocument1',
    '8': 'AdditionalDocument2',
    '9': 'AdditionalDocument3',
    '10': 'CDSLicense',
    '11': 'AttestationDocument',
    '12': 'CorporateAuthorityForm',
    '13': 'UniformRequirements',
    '14': 'ParticipatingAgreement',
    '15': 'MissouriMedicareAdvantage',
    '16': 'W9Form',
    '17': 'CredentialingApplication',
}

const enum Specialities {
    Endodontics = 2,
    GeneralDentistry = 1,
    OralSurgery = 6,
    Orthodontics = 7,
    PediatricDentistry = 8,
    Periodontics = 11,
    Prosthodontics = 12,
}

export { DocumentCategory, DocumentSubCategory, DocumentSubCategoryName, Specialities };